import Button from "react-bootstrap/Button";
import { ReactNode, useState } from "react";
import { IconChevronDown, IconChevronUp } from "../Icon/Icon.tsx";

type AccordionModel = {
  title: ReactNode;
  content: ReactNode;
  onClick: void;
  isOpen: boolean;
  className?: string;
};

const Accordion = ({ title, content }: AccordionModel) => {
  const [isActive, setIsActive] = useState(false);

  return (
    <>
      <Button
        variant={"outline-success"}
        className={"rounded-pill p-3 mb-2"}
        onClick={() => setIsActive(!isActive)}
      >
        <div>
          {title} {isActive ? <IconChevronUp /> : <IconChevronDown />}
        </div>
      </Button>
      {isActive && (
        <div className={"mt-1 bg-light p-2 rounded-5 p-3"}>{content}</div>
      )}
    </>
  );
};

export default Accordion;
